import { render, staticRenderFns } from "./slotMachine.vue?vue&type=template&id=ec3cbb4a&scoped=true"
import script from "./slotMachine.vue?vue&type=script&lang=js"
export * from "./slotMachine.vue?vue&type=script&lang=js"
import style0 from "./slotMachine.vue?vue&type=style&index=0&id=ec3cbb4a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec3cbb4a",
  null
  
)

export default component.exports